import React from 'react';

import { Box } from '@mui/material';

import AppLogo from '../AppLogo';
import { env } from '../../../../env';
import UserAvatarButton from '../UserAvatarButton';
import LogoutButton from '../LogoutButton';

import ROUTES from '../../../../constants/routes';

import { IAppHeader } from './interfaces';

import { useStyles } from './styles';
import FullScreenButton from '../FullScreenButton';
import BackButton from '../../auth/components/BackButton';

const { REACT_APP_SHOW_PROFILE } = env;

const AppHeader = ({
  isAuthorized = false,
  onBackClick,
  isHideLogo = false,
}: IAppHeader) => {
  const classes = useStyles();
  const showProfile = REACT_APP_SHOW_PROFILE === 'true';

  return (
    <Box sx={classes.root}>
      <Box sx={classes.box}>
        {!!onBackClick && <BackButton onClick={onBackClick} />}
      </Box>
      {isHideLogo ? null : (
        <Box sx={{ ...classes.box, ...classes.logo }}>
          <AppLogo to={isAuthorized ? ROUTES.SELECT_EVENT : ROUTES.LOGIN} />
        </Box>
      )}
      <Box sx={classes.actionsContainer}>
        <FullScreenButton />
        {isAuthorized ? (
          <>
            {showProfile ? <UserAvatarButton /> : null}
            <LogoutButton />
          </>
        ) : null}
      </Box>
    </Box>
  );
};

export default AppHeader;
